export default __webpack_public_path__ + "static/media/Redis_Logo.01c711ff.svg";